import {Checkbox} from 'antd';
import React, {FunctionComponent, useState} from 'react';
import {useDispatch} from 'react-redux';

import {IFieldsState} from 'components/table/table-types';
import {IFieldMeta} from 'entities/metadata';
import {TEntity, TEntityValue} from 'modules/data';
import {setData} from 'modules/data/data-actions';
import {EEntityType} from 'shared/constants/entities';
import {normalizeBoolValue, normalizeBoolValueString} from 'utils/common';

interface IColumnSelectAllCheckboxProps {
    entityName: string;
    fieldMeta: IFieldMeta;
    rows: Record<string, TEntityValue>[] | undefined;
    editRows: Record<string, TEntityValue>[] | undefined;
    fieldsState: IFieldsState;
}

export const ColumnSelectAllCheckbox: FunctionComponent<IColumnSelectAllCheckboxProps> = ({
    entityName,
    fieldMeta,
    rows,
    editRows,
    fieldsState,
}: IColumnSelectAllCheckboxProps) => {
    const dispatch = useDispatch();
    const checkIsAllSelected = !!rows?.every(el => normalizeBoolValue(el[fieldMeta.key]));
    const [isAllSelected, setIsAllSelected] = useState<boolean>(checkIsAllSelected);
    const {key, label} = fieldMeta;

    const changeCheckboxesState = () => {
        setIsAllSelected(!isAllSelected);
        const copyEditRows: TEntity[] = editRows || [];
        const copyRows = rows?.map(row => {
            if (!isAllSelected === normalizeBoolValue(row[key])) {
                return row;
            }

            const rowState = fieldsState[row.id as number];
            const fieldState = rowState ? rowState[key] : undefined;
            const {disabled = false} = fieldState || {};

            let newRow = { ...row };

            if (!disabled) {
                newRow = {
                    ...newRow,
                    [key]: normalizeBoolValueString(!isAllSelected)
                };
            }

            if (copyEditRows.some(editRow => ((editRow?.id !== null
                ? editRow?.id === row?.id
                : editRow?.uniqId === newRow?.uniqId)))) {
                const indexEditRow: number = copyEditRows.findIndex(editRow => (editRow?.id !== null
                    ? editRow?.id === row?.id
                    : editRow?.uniqId === newRow?.uniqId));
                copyEditRows.splice(indexEditRow, 1);
            } else {
                copyEditRows.push(newRow);
            }
            return newRow;
        });

        dispatch(setData({
            entityName,
            entityType: EEntityType.TABLE,
            data: {
                rows: [...copyRows || []],
                editRows: [...copyEditRows || []],
            },
        }));
    };

    return (
        <Checkbox
            checked={isAllSelected}
            onClick={changeCheckboxesState}
        >
            {label}
        </Checkbox>
    );
};
